import { render, staticRenderFns } from "./vipDetail.vue?vue&type=template&id=88b96ad8&scoped=true&"
import script from "./vipDetail.vue?vue&type=script&lang=ts&"
export * from "./vipDetail.vue?vue&type=script&lang=ts&"
import style0 from "./vipDetail.vue?vue&type=style&index=0&id=88b96ad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b96ad8",
  null
  
)

export default component.exports